import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../../../components/navbar';
import Footer from '../../../../components/footer';
import Button from '../../../../components/Button';
import Checkbox from '../../../../components/Checkbox';
import Dropdown from '../../../../components/Dropdown';
import { useConsultation } from '../../../../context/ConsultationContext';
import { handleTreatmentServiceNavigation } from '../components/treatmentNavigationHelper';
import styles from './css/BloodPressure.module.css';
import newStyle from './css/BabyImmunization.module.css';
import { Baby, Send } from 'lucide-react';

const BabyImmunization = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { consultationData, updateConsultationData, getStepDraft, setStepDraft, goToStep } = useConsultation();

    const patient = location?.state?.patient || consultationData?.patient || {};
    const patientName = `${patient?.firstname || ""} ${patient?.surname || ""}`.trim() || "Thandiwe Ndlovu";
    const profileNumber = patient?.profilenumber || "448896";
    const initials = `${patient?.firstname?.[0] || ""}${patient?.surname?.[0] || ""}`.toUpperCase() || "TN";

    const [vaccineName, setVaccineName] = useState('');
    const [batchNumber, setBatchNumber] = useState('');
    const [site, setSite] = useState('');
    const [nextDueDate, setNextDueDate] = useState('');
    const [duration, setDuration] = useState('');

    const [adverseReactions, setAdverseReactions] = useState({
        adverseReactionObserved: false,
        patientMonitored: false,
        none: false,
    });
    const [tetanusUpToDate, setTetanusUpToDate] = useState(false);

    const [dressingApplied, setDressingApplied] = useState('');
    const [clinicalNotes, setClinicalNotes] = useState('');

    const handleAdverseReactionChange = (key) => {
        setAdverseReactions((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleInvoice = () => {
        handleTreatmentServiceNavigation({
            location,
            navigate,
            consultationData,
            updateConsultationData,
            getStepDraft,
            setStepDraft,
            goToStep,
            serviceData: {
                baby_immunization: {
                    vaccineName,
                    batchNumber,
                    site,
                    nextDueDate,
                    duration,
                    adverseReactions,
                    tetanusUpToDate,
                    dressingApplied,
                    clinicalNotes,
                },
            },
        });
    };

    useEffect(() => {
        document.body.classList.add(styles.hideSidebar);
        return () => {
            document.body.classList.remove(styles.hideSidebar);
        };
    }, []);

    return (
        <div className={styles.bloodPressureContainer}>
            <Navbar />

            <main className={styles.mainContent}>
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <div className={styles.headerIcon} aria-hidden="true">
                            <Baby />
                        </div>
                        <h1 className={newStyle.title}>Baby Immunization</h1>
                    </div>

                    <div className={styles.patientCard}>
                        <div className={styles.avatar} aria-hidden="true">{initials}</div>
                        <div className={styles.patientText}>
                            <div className={styles.patientName}>{patientName}</div>
                            <div className={styles.patientMetaRow}>
                                <span className={styles.profileInfo}>Profile: {profileNumber}</span>
                                <span className={styles.dependentBadge}>Dependent</span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>VACCINE DETAILS</div>

                        <div className={newStyle.detailsRow}>
                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Vaccine Name</label>
                                <input
                                    type="text"
                                    value={vaccineName}
                                    onChange={(e) => setVaccineName(e.target.value)}
                                    className={styles.readingInput}
                                    placeholder="e.g., Hexaxim"
                                />
                            </div>

                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Batch Number</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="text"
                                        value={batchNumber}
                                        onChange={(e) => setBatchNumber(e.target.value)}
                                        className={styles.readingInput}
                                        placeholder="e.g., U789JD"
                                    />
                                </div>
                            </div>

                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Site</label>
                                <input
                                    type="text"
                                    value={site}
                                    onChange={(e) => setSite(e.target.value)}
                                    className={styles.readingInput}
                                />
                            </div>

                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Next Due date</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="date"
                                        value={nextDueDate}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '' || /^\d{4}-\d{2}-\d{2}$/.test(value)) {
                                                setNextDueDate(value);
                                            }
                                        }}
                                        className={styles.readingInput}
                                        placeholder="YYYY-MM-DD"
                                        min="1900-01-01"
                                        max="2100-12-31"
                                    />
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>ADVERSE REACTIONS</div>
                        <div className={styles.symptomsList}>
                            <div className={styles.checkboxItem}>
                                <Checkbox
                                    id="adverseReactionObserved"
                                    checked={adverseReactions.adverseReactionObserved}
                                    onChange={() => handleAdverseReactionChange('adverseReactionObserved')}
                                />
                                <label htmlFor="adverseReactionObserved" className={styles.checkboxLabel}>Adverse reaction observed</label>
                            </div>

                            <div className={styles.checkboxItem}>
                                <Checkbox
                                    id="patientMonitored"
                                    checked={adverseReactions.patientMonitored}
                                    onChange={() => handleAdverseReactionChange('patientMonitored')}
                                />
                                <label htmlFor="patientMonitored" className={styles.checkboxLabel}>Patient monitored for 15 min post-vaccine</label>
                            </div>

                            <div className={styles.checkboxItem}>
                                <Checkbox
                                    id="none"
                                    checked={adverseReactions.none}
                                    onChange={() => handleAdverseReactionChange('none')}
                                />
                                <label htmlFor="none" className={styles.checkboxLabel}>None</label>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.fieldLabel}>Clinical Notes</div>
                        <textarea
                            value={clinicalNotes}
                            onChange={(e) => setClinicalNotes(e.target.value)}
                            className={styles.clinicalNotes}
                            placeholder="Enter clinical notes..."
                            rows={6}
                        />
                    </div>

                    <div className={styles.cardFooter}>
                        <Button
                            onClick={handleInvoice}
                            className={styles.invoiceButton}
                            type="button"
                        >
                            <Send size={16} />
                            Invoice
                        </Button>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default BabyImmunization;